import { OrdersActionsTypes } from '../../../enums/ActionEnums';
export const ordersActions = {
    getOrderedItemsForAuthenticatedUser: () => ({
        type: OrdersActionsTypes.GET_ORDERED_ITEMS_FOR_AUTHENTICATED_USER,
    }),
    getOrderedItemsForGuestUser: () => ({
        type: OrdersActionsTypes.GET_ORDERED_ITEMS_FOR_GUEST_USER,
    }),
    setOrderedItems: (items) => ({
        type: OrdersActionsTypes.SET_ORDERED_ITEMS,
        payload: items,
    }),
    // Return items
    getReturnItems: () => ({
        type: OrdersActionsTypes.GET_RETURN_ITEMS,
    }),
    setReturnItems: (payload) => ({
        type: OrdersActionsTypes.SET_RETURN_ITEMS,
        payload,
    }),
    setAnnouncedReturn: (payload) => ({
        type: OrdersActionsTypes.SET_ANNOUNCED_RETURN,
        payload,
    }),
    getReturnReasons: () => ({
        type: OrdersActionsTypes.GET_RETURN_REASONS,
    }),
    setReturnReasons: (payload) => ({
        type: OrdersActionsTypes.SET_RETURN_REASONS,
        payload,
    }),
    submitReturnItems: (payload) => ({
        type: OrdersActionsTypes.SUBMIT_RETURN_ITEMS,
        payload,
    }),
    updateReturnReason: (payload) => ({
        type: OrdersActionsTypes.UPDATE_RETURN_REASON,
        payload,
    }),
    getReturnedSales: () => ({
        type: OrdersActionsTypes.GET_RETURNED_SALES,
    }),
    setReturnedSales: (payload) => ({
        type: OrdersActionsTypes.SET_RETURNED_SALES,
        payload,
    }),
    setSubmitReturnItemsState: (payload) => ({
        type: OrdersActionsTypes.SET_SUBMIT_RETURN_ITEMS_STATE,
        payload,
    }),
    setUpdateAnnouncedReturnState: (payload) => ({
        type: OrdersActionsTypes.SET_UPDATE_ANNOUNCED_RETURN_STATE,
        payload,
    }),
    setOrderedItemsState: (payload) => ({
        type: OrdersActionsTypes.SET_ORDERED_ITEMS_STATE,
        payload,
    }),
};
